import { create } from 'zustand';

import { EventItem } from 'src/types/analytics/event';

type States = {
  events: EventItem[];
  analyticsDeviceId: string | null;
};

type Actions = {
  addEvent: (value: EventItem) => void;
  clearEvents: () => void;
  setAnalyticsDeviceId: (id: string) => void;
};

type Analytics = Actions & States;

const initialValues = {
  events: JSON.parse(localStorage.getItem('events') ?? '[]'),
  analyticsDeviceId: localStorage.getItem('analyticsDeviceId'),
};


export const useAnalytics = create<Analytics>((set: any, get: any) => ({
  ...initialValues,

  addEvent(event: any) {
    set({ events: [...get().events, event] })
  },

  clearEvents() {
    set({ events: [] })
  },

  setAnalyticsDeviceId(id: string) {
    set({ analyticsDeviceId: id });
    localStorage.setItem('analyticsDeviceId', id);
  },

}));
